module.exports = __webpack_public_path__ + "img/digitalEvaluationBannerRed.e78b6210.jpg";